var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"IndexSICCIJ_div"}},[_c('menusuperior',{attrs:{"titulo":"SICCIJ","subtitulo":"Sistema de control de citas de juzgado"}}),_vm._v(" "),_c('menuizquierda'),_vm._v(" "),_c('div',{staticClass:"content-area"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a3b7386","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SICCIJ/Comun/Plantilla.vue
// module id = null
// module chunks = 